"use strict";
/**
 * Motion tokens for every channel. Two laws apply everywhere:
 *   1. Animate transform and opacity only (no width/height/top/left/margin/
 *      padding), so nothing reflows while a class is live.
 *   2. Anything a finger touches is a spring that starts from the on-screen
 *      value and keeps its velocity, so it can be grabbed and redirected.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.motion = exports.flickVelocity = exports.stagger = exports.watch = exports.press = exports.spring = exports.web = void 0;
exports.project = project;
exports.rubberband = rubberband;
/** Web / dashboard: one strong ease-out, short durations, no bounce. */
exports.web = {
    ease: 'cubic-bezier(0.16, 1, 0.3, 1)',
    easeBezier: [0.16, 1, 0.3, 1],
    duration: {
        /** Press feedback, small state changes. */
        fast: 180,
        /** Popovers, row moves, tab content. */
        base: 220,
        /** Dialogs, page entrances, layout reflows. */
        slow: 280,
    },
};
/**
 * Mobile springs (Reanimated `withSpring` physics config).
 * Critical damping for mass 1 / stiffness 300 is 2·√300 ≈ 34.6.
 */
exports.spring = {
    /** Default for gestures and sheets — damping ratio ≈ 0.81, a hint of overshoot. */
    default: { damping: 28, stiffness: 300, mass: 1 },
    /** Commits that must land crisply (checkmarks, slide-to-confirm, snaps) — ratio ≈ 0.82, ~2× faster. */
    tight: { damping: 40, stiffness: 600, mass: 1 },
    /** Values that must never overshoot (digits, colors, progress) — critically damped. */
    settle: { damping: 35, stiffness: 300, mass: 1 },
};
/** Press feedback on every pressable, all channels. */
exports.press = { scale: 0.97, inMs: 100 };
/** Watch / compact: sharp and linear, nothing that delays a glance. */
exports.watch = { durationMs: 120, easing: 'linear' };
/** Sequential entry for rows (workout sets, leaderboards, activity lists). */
exports.stagger = { stepMs: 50, maxItems: 8 };
/** Velocity at which a flick commits regardless of distance (px/ms). */
exports.flickVelocity = 0.11;
/** Where a flick would come to rest (Apple's decay projection; v in px/s). */
function project(velocity, decelerationRate = 0.998) {
    'worklet';
    return ((velocity / 1000) * decelerationRate) / (1 - decelerationRate);
}
/** Progressive resistance past a boundary instead of a hard stop. */
function rubberband(overshoot, dimension, constant = 0.55) {
    'worklet';
    return (overshoot * dimension * constant) / (dimension + constant * Math.abs(overshoot));
}
exports.motion = { web: exports.web, spring: exports.spring, press: exports.press, watch: exports.watch, stagger: exports.stagger, flickVelocity: exports.flickVelocity };
//# sourceMappingURL=motion.js.map